<template>
    <xx-search-form
        v-model="query"
        :fields="searchFields"
        @submit="onSearch"
        @reset="onReset"
    >
        <template slot="skuNameOrId">
            <el-input
                v-model="query.skuNameOrId"
                placeholder="请输入商品名/skuId"
                :maxlength="30"
                :clearable="true"
            />
        </template>
        <template slot="code">
            <el-input
                v-model="query.code"
                placeholder="请输入询价单号"
                :maxlength="30"
                :clearable="true"
            />
        </template>
    </xx-search-form>
</template>
<script>
import { getDefaultSearchParams, getSearchFormFields } from '../config';

export default {
    name: 'SearchForm',
    props: {},
    data() {
        return {
            query: getDefaultSearchParams(),
        };
    },
    computed: {
        searchFields() {
            return getSearchFormFields.call(this);
        },
    },
    methods: {
        reset() {
            this.query = getDefaultSearchParams();
            this.$emit('reset');
        },
        onSearch() {
            this.$emit('search', { ...this.query });
        },
        onReset() {
            this.reset();
        },
    },
};
</script>
